import React, { useMemo, useState, useEffect } from "react";
import { Button } from "./ui";
import { ArrowDownAZ, ArrowUpZA, ZoomIn, ZoomOut, ArrowDownWideNarrow, ArrowUpNarrowWide, Network, ListOrdered, User, Palette, Save, X } from "lucide-react";
import { orderGenericGroups, gradeOfPerson as gradeOf } from "../lib/orgRank";

const OC_CSS = `
.oc{display:flex;flex-direction:column;align-items:center;padding:8px 4px 20px;}
.oc-level{display:flex;flex-direction:column;align-items:center;}
.oc-drop{width:2px;height:16px;background:#8a99b8;}
.oc-row{display:flex;justify-content:center;align-items:flex-start;}
.oc-cell{position:relative;padding:16px 8px 0;display:flex;justify-content:center;}
.oc-has-parent>.oc-row>.oc-cell::before{content:"";position:absolute;top:0;left:50%;width:2px;height:16px;background:#8a99b8;}
.oc-has-parent>.oc-row>.oc-cell::after{content:"";position:absolute;top:0;left:0;right:0;height:2px;background:#8a99b8;}
.oc-has-parent>.oc-row>.oc-cell:first-child::after{left:50%;}
.oc-has-parent>.oc-row>.oc-cell:last-child::after{right:50%;}
.oc-has-parent>.oc-row>.oc-cell:only-child::after{display:none;}
.oc-group{background:rgba(15,98,254,.03);border:1px solid rgba(0,0,0,.1);border-radius:10px;overflow:hidden;}
.dark .oc-group{background:rgba(255,255,255,.03);border-color:rgba(255,255,255,.12);}
.oc-gbar{display:flex;align-items:center;gap:6px;padding:4px 10px;background:var(--nc,#0F62FE);color:#fff;font-weight:700;font-size:12px;}
.oc-gbar .rkb{display:inline-flex;width:17px;height:17px;align-items:center;justify-content:center;border-radius:4px;background:rgba(255,255,255,.25);font-size:10px;font-weight:800;flex:0 0 auto;}
.oc-gbar .nm{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.oc-gbar .cnt{margin-left:auto;font-weight:500;opacity:.9;font-size:10px;flex:0 0 auto;}
.oc-cards{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;padding:8px;}
.oc-card3{width:130px;background:#fff;border:1px solid rgba(0,0,0,.12);border-top:3px solid var(--nc,#0F62FE);border-radius:8px;box-shadow:0 1px 5px rgba(0,0,0,.13);padding:7px 8px;cursor:pointer;transition:box-shadow .15s,transform .15s;}
.oc-card3:hover{box-shadow:0 3px 12px rgba(0,0,0,.2);transform:translateY(-1px);}
.dark .oc-card3{background:#1b1c22;border-color:rgba(255,255,255,.14);box-shadow:0 1px 5px rgba(0,0,0,.4);}
.oc-card3 .l1{font-weight:700;font-size:12px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.oc-card3 .l2{font-size:11px;opacity:.75;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.oc-card3 .l3{font-size:10.5px;opacity:.6;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.oc-unit{position:relative;width:210px;min-width:150px;background:#fff;border:1px solid rgba(0,0,0,.12);border-radius:8px;box-shadow:0 1px 6px rgba(0,0,0,.14);overflow:hidden;}
.oc-grip{position:absolute;top:0;bottom:0;width:8px;cursor:ew-resize;z-index:5;background:rgba(255,255,255,.001);}
.oc-grip-l{left:0;} .oc-grip-r{right:0;}
.oc-grip:hover{background:rgba(255,255,255,.5);}
.dark .oc-unit{background:#1b1c22;border-color:rgba(255,255,255,.14);box-shadow:0 1px 6px rgba(0,0,0,.4);}
.oc-bar{display:flex;align-items:center;gap:6px;padding:5px 9px;background:var(--nc,#0F62FE);color:#fff;font-weight:700;font-size:12px;}
.oc-bar .rkb{display:inline-flex;width:17px;height:17px;align-items:center;justify-content:center;border-radius:4px;background:rgba(255,255,255,.25);font-size:10px;font-weight:800;flex:0 0 auto;}
.oc-bar .nm{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.oc-bar .cnt{margin-left:auto;font-weight:500;opacity:.9;font-size:10px;flex:0 0 auto;}
.oc-mem{display:flex;align-items:center;gap:8px;padding:6px 9px;border-top:1px solid rgba(0,0,0,.07);text-align:left;width:100%;background:transparent;cursor:pointer;transition:background .12s;}
.dark .oc-mem{border-top-color:rgba(255,255,255,.08);}
.oc-mem:hover{background:rgba(15,98,254,.07);}
.oc-mem .ava{width:30px;height:30px;border-radius:50%;overflow:hidden;flex:0 0 auto;display:flex;align-items:center;justify-content:center;background:color-mix(in srgb, var(--nc,#0F62FE) 16%, transparent);color:var(--nc,#0F62FE);border:1px solid rgba(0,0,0,.08);}
.dark .oc-mem .ava{border-color:rgba(255,255,255,.14);}
.oc-mem .ava img{width:100%;height:100%;object-fit:cover;}
.oc-mem .num{width:16px;text-align:center;font-weight:800;color:var(--nc,#0F62FE);font-size:11px;flex:0 0 auto;}
.oc-mem .body{min-width:0;flex:1;display:flex;align-items:baseline;gap:8px;}
.oc-mem .nm{min-width:0;font-size:11.5px;font-weight:600;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.oc-mem .meta{flex:0 0 auto;font-size:10px;opacity:.65;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
`;

export default function RankBoard({ people = [], tree, onPersist, onEdit, onIdeaFilter, rawAge, nameOf, gradeAmount, fmtMoney }) {
  const [dir, setDir] = useState(tree?.rank_dir === "desc" ? "desc" : "asc"); // dept/unit order by rank letter; asc = A at top
  const [rankBy, setRankBy] = useState(tree?.rank_people_by || "salary_grade");
  const [memberDir, setMemberDir] = useState(tree?.rank_member_dir === "asc" ? "asc" : "desc"); // salary within a unit
  const [view, setView] = useState(tree?.rank_view || "dept"); // "dept" = Department/Unit View, "rank" = Unit Rank View
  const [zoom, setZoom] = useState(1);
  const [widths, setWidths] = useState({}); // Unit Rank View: per-unit box width (session-local) for reading long names
  const [unitColors, setUnitColors] = useState(tree?.rank_unit_colors || {}); // per-unit banner colour overrides
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerUnit, setPickerUnit] = useState("");
  const [hoverColor, setHoverColor] = useState("");
  const [ideaMode, setIdeaMode] = useState(tree?.rank_idea_mode === "override" ? "override" : "on"); // "on" = apply IDEA order; "override" = ignore IDEA flags
  const [presetName, setPresetName] = useState("");
  const presets = tree?.rank_presets || [];
  const [ideaFilter, setIdeaFilter] = useState(null); // {key, value} — click a tally chip to highlight matching people
  const IDEA_CAT_KEY = { "First Designation": "gx1", "Second Designation": "gx4", "Exigency": "gx2" };
  const matchesFilter = (p) => !ideaFilter || (p.attrs?.[ideaFilter.key] ?? "").toString().trim() === String(ideaFilter.value);
  const toggleFilter = (key, value) => setIdeaFilter((cur) => (cur && cur.key === key && String(cur.value) === String(value)) ? null : { key, value });
  useEffect(() => { if (onIdeaFilter) onIdeaFilter(ideaFilter); }, [ideaFilter]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => () => { if (onIdeaFilter) onIdeaFilter(null); }, []); // clear scope when leaving the diagram

  const PRESETS = ["#0F62FE", "#0043CE", "#24A148", "#198038", "#D02670", "#9F1853", "#FF832B", "#EE538B", "#8A3FFC", "#6929C4", "#007D79", "#005D5D", "#B28600", "#4D4D4D", "#161616"];
  const hslToHex = (h, s, l) => { s /= 100; l /= 100; const k = (n) => (n + h / 30) % 12; const a = s * Math.min(l, 1 - l); const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1))); const to = (x) => Math.round(255 * x).toString(16).padStart(2, "0"); return `#${to(f(0))}${to(f(8))}${to(f(4))}`; };
  const hueFromEvent = (e) => { const r = e.currentTarget.getBoundingClientRect(); const pct = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)); return hslToHex(Math.round(pct * 360), 72, 48); };
  const assignColor = (c) => { const next = { ...unitColors, [pickerUnit]: c }; setUnitColors(next); persist({ rank_unit_colors: next }); };
  const clearColor = () => { const next = { ...unitColors }; delete next[pickerUnit]; setUnitColors(next); persist({ rank_unit_colors: next }); setHoverColor(""); };

  const startResize = (e, name, side) => {
    e.preventDefault(); e.stopPropagation();
    const box = e.currentTarget.parentElement;
    const startX = e.clientX;
    const startW = box.getBoundingClientRect().width / zoom;
    document.body.style.userSelect = "none";
    const onMove = (ev) => {
      const dx = (ev.clientX - startX) / zoom;
      const w = Math.max(150, Math.round(startW + (side === "right" ? dx : -dx)));
      setWidths((m) => ({ ...m, [name]: w }));
    };
    const onUp = () => {
      document.body.style.userSelect = "";
      window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  const persist = (patch) => onPersist && onPersist({ rank_dir: dir, rank_people_by: rankBy, rank_member_dir: memberDir, rank_view: view, ...patch });
  const setDirP = (d) => { setDir(d); persist({ rank_dir: d }); };
  const setRankByP = (b) => { setRankBy(b); persist({ rank_people_by: b }); };
  const setMemberDirP = (d) => { setMemberDir(d); persist({ rank_member_dir: d }); };
  const setViewP = (v) => { setView(v); persist({ rank_view: v }); };
  const setIdeaModeP = (m) => { setIdeaMode(m); persist({ rank_idea_mode: m }); };
  const applyPreset = (p) => {
    const c = p?.cfg || {};
    const v = c.rank_view || "dept", d = c.rank_dir || "asc", rb = c.rank_people_by || "salary_grade";
    const md = c.rank_member_dir || "desc", im = c.rank_idea_mode || "on", uc = c.rank_unit_colors || {};
    setView(v); setDir(d); setRankBy(rb); setMemberDir(md); setIdeaMode(im); setUnitColors(uc);
    onPersist && onPersist({ rank_view: v, rank_dir: d, rank_people_by: rb, rank_member_dir: md, rank_idea_mode: im, rank_unit_colors: uc });
  };
  const saveView = () => {
    const name = presetName.trim();
    if (!name) return;
    const cfg = { rank_view: view, rank_dir: dir, rank_people_by: rankBy, rank_member_dir: memberDir, rank_idea_mode: ideaMode, rank_unit_colors: unitColors };
    const next = [...presets.filter((p) => p.name !== name), { name, cfg }];
    persist({ rank_presets: next });
    setPresetName("");
  };
  const deletePreset = (name) => { persist({ rank_presets: presets.filter((p) => p.name !== name) }); };

  // Department/unit groups, ordered by rank letter; members salary-ranked within.
  const groups = useMemo(() => {
    const g = orderGenericGroups(people, { dir, rankBy, rawAge, applyIdea: ideaMode === "on" });
    if (memberDir === "asc") return g.map((x) => ({ ...x, members: [...x.members].reverse() }));
    return g;
  }, [people, dir, rankBy, rawAge, memberDir, ideaMode]);

  // At-a-glance IDEA tallies (First/Second Designation, Exigency) across the current roster.
  const ideaTallies = useMemo(() => {
    const tally = (key) => {
      const m = new Map();
      people.forEach((p) => { const v = (p.attrs?.[key] ?? "").toString().trim(); if (v) m.set(v, (m.get(v) || 0) + 1); });
      return [...m.entries()].sort((a, b) => (b[1] - a[1]) || String(a[0]).localeCompare(String(b[0])));
    };
    return { first: tally("gx1"), second: tally("gx4"), exig: tally("gx2") };
  }, [people]);

  // Tiers of DEPARTMENTS (units) by rank letter, for the branching Department/Unit View.
  const tiers = useMemo(() => {
    const order = []; const map = new Map();
    groups.forEach((u) => {
      const key = u.rank || "\uffff";
      if (!map.has(key)) { map.set(key, { rank: u.rank || "", units: [] }); order.push(key); }
      map.get(key).units.push(u);
    });
    return order.map((k) => map.get(k));
  }, [groups]);

  const memberMeta = (p) => {
    const gr = gradeOf(p); const amt = gr > 0 && gradeAmount ? gradeAmount(gr) : 0;
    const flags = [];
    if (p.attrs?.desig_rank === "master") flags.push("★ Master (Desig)");
    else if (p.attrs?.desig_rank === "submaster") flags.push("Submaster (Desig)");
    if (p.attrs?.exig_rank === "master") flags.push("★ Master (Exig)");
    else if (p.attrs?.exig_rank === "submaster") flags.push("Submaster (Exig)");
    return [...flags, p.attrs?.title, gr > 0 ? `G${gr}${amt ? ` (${fmtMoney(amt)})` : ""}` : null].filter(Boolean).join(" · ");
  };

  const unitNames = useMemo(() => groups.map((g) => g.name), [groups]);
  const defaultColorOf = (name) => groups.find((g) => g.name === name)?.members[0]?.color || "#0F62FE";
  const bannerColor = (u) => (pickerUnit === u.name && hoverColor) ? hoverColor : (unitColors[u.name] || u.members[0]?.color || "#0F62FE");

  return (
    <div data-testid="rank-board">
      <div className="mb-3 rounded-lg border border-black/10 bg-white/50 p-2 dark:border-white/10 dark:bg-white/[0.03]">
        <div className="mb-2 text-xs font-semibold opacity-70">View</div>
        <div className="flex flex-wrap items-center gap-2">
        <div className="flex rounded-md border border-black/15 p-0.5 dark:border-white/15">
          <button onClick={() => setViewP("dept")} data-testid="rank-view-dept" title="Org chart with a name bar above each department/unit"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${view === "dept" ? "bg-[var(--primary)] text-white" : ""}`}><Network size={14} /> Department/Unit View</button>
          <button onClick={() => setViewP("rank")} data-testid="rank-view-rank" title="Each unit's people listed vertically by salary rank"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${view === "rank" ? "bg-[var(--primary)] text-white" : ""}`}><ListOrdered size={14} /> Unit Rank View</button>
        </div>

        <span className="ms-2 text-xs font-semibold opacity-70">Units by rank</span>
        <div className="flex rounded-md border border-black/15 p-0.5 dark:border-white/15">
          <button onClick={() => setDirP("asc")} data-testid="rank-dir-asc" title="A at top / first"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${dir === "asc" ? "bg-[var(--primary)] text-white" : ""}`}><ArrowDownAZ size={14} /> A→Z</button>
          <button onClick={() => setDirP("desc")} data-testid="rank-dir-desc" title="Z at top / first"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${dir === "desc" ? "bg-[var(--primary)] text-white" : ""}`}><ArrowUpZA size={14} /> Z→A</button>
        </div>

        <span className="ms-2 text-xs font-semibold opacity-70">People by</span>
        <select value={rankBy} onChange={(e) => setRankByP(e.target.value)} data-testid="rank-people-by"
          className="rounded-md border border-black/15 bg-transparent px-2 py-1 text-xs dark:border-white/15">
          <option value="salary_grade">Salary Grade</option>
          <option value="age">Age</option>
        </select>
        <div className="flex rounded-md border border-black/15 p-0.5 dark:border-white/15">
          <button onClick={() => setMemberDirP("desc")} data-testid="rank-member-desc" title="Highest at top"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${memberDir === "desc" ? "bg-[var(--primary)] text-white" : ""}`}><ArrowDownWideNarrow size={14} /> High→Low</button>
          <button onClick={() => setMemberDirP("asc")} data-testid="rank-member-asc" title="Lowest at top"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${memberDir === "asc" ? "bg-[var(--primary)] text-white" : ""}`}><ArrowUpNarrowWide size={14} /> Low→High</button>
        </div>

        <span className="ms-2 text-xs font-semibold opacity-70">IDEA</span>
        <div className="flex rounded-md border border-black/15 p-0.5 dark:border-white/15">
          <button onClick={() => setIdeaModeP("on")} data-testid="idea-mode-on" title="Apply the Master/Submaster ordering from the IDEA fields"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${ideaMode === "on" ? "bg-[var(--primary)] text-white" : ""}`}>Display IDEA</button>
          <button onClick={() => setIdeaModeP("override")} data-testid="idea-mode-override" title="Ignore the IDEA Master/Submaster flags and display as if none were selected"
            className={`flex items-center gap-1 rounded px-2 py-1 text-xs ${ideaMode === "override" ? "bg-[var(--primary)] text-white" : ""}`}>Display Override IDEA</button>
        </div>

        <div className="ms-auto flex items-center gap-2">
          <div className="relative">
            <Button variant={Object.keys(unitColors).length ? "primary" : "ghost"} onClick={() => setPickerOpen((o) => !o)} data-testid="banner-color-btn" title="Colour-code department/unit banners"><Palette size={14} /> Banner colours</Button>
            {pickerOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => { setPickerOpen(false); setHoverColor(""); }} data-testid="banner-color-backdrop" />
                <div className="absolute end-0 top-full z-50 mt-1 w-72 rounded-lg border border-black/10 bg-white p-3 shadow-xl dark:border-white/15 dark:bg-[#1b1c22]" data-testid="banner-color-panel" onClick={(e) => e.stopPropagation()}>
                  <div className="mb-2 text-xs font-semibold">Colour-code banners</div>
                  <select value={pickerUnit} onChange={(e) => { setPickerUnit(e.target.value); setHoverColor(""); }} data-testid="banner-color-unit"
                    className="w-full rounded-md border border-black/15 bg-transparent px-2 py-1 text-xs dark:border-white/15">
                    <option value="">Select a department / unit…</option>
                    {unitNames.map((n) => <option key={n} value={n}>{n}</option>)}
                  </select>
                  {pickerUnit ? (
                    <>
                      <div className="mt-2 flex items-center gap-2">
                        <span className="text-[11px] opacity-70">Sample:</span>
                        <span className="min-w-0 flex-1 truncate rounded px-2 py-1 text-[11px] font-semibold text-white" style={{ background: hoverColor || unitColors[pickerUnit] || defaultColorOf(pickerUnit) }} data-testid="banner-color-sample">{pickerUnit}</span>
                      </div>
                      <div className="mt-2 flex flex-wrap gap-1.5" data-testid="banner-swatches">
                        {PRESETS.map((c) => (
                          <button key={c} onClick={() => assignColor(c)} onMouseEnter={() => setHoverColor(c)} onMouseLeave={() => setHoverColor("")}
                            className="h-6 w-6 rounded-full border border-black/20 transition-transform hover:scale-110 dark:border-white/20"
                            style={{ background: c }} title={c} data-testid={`banner-swatch-${c}`} />
                        ))}
                      </div>
                      <div className="mt-2 text-[11px] opacity-70">Or hover the spectrum &amp; click to assign:</div>
                      <div className="mt-1 h-7 w-full cursor-crosshair rounded"
                        style={{ background: "linear-gradient(to right, hsl(0,72%,48%), hsl(60,72%,48%), hsl(120,72%,48%), hsl(180,72%,48%), hsl(240,72%,48%), hsl(300,72%,48%), hsl(360,72%,48%))" }}
                        onMouseMove={(e) => setHoverColor(hueFromEvent(e))} onMouseLeave={() => setHoverColor("")} onClick={(e) => assignColor(hueFromEvent(e))} data-testid="banner-gradient" />
                      <div className="mt-2 flex items-center justify-between">
                        <button onClick={clearColor} className="text-[11px] underline opacity-70" data-testid="banner-color-reset">Reset to default</button>
                        <span className="text-[11px] opacity-60">{(hoverColor || unitColors[pickerUnit] || "").toUpperCase()}</span>
                      </div>
                    </>
                  ) : <div className="mt-2 text-[11px] opacity-60">Pick a unit to colour its banner across both views.</div>}
                </div>
              </>
            )}
          </div>
          <div className="flex items-center gap-1">
            <Button variant="ghost" onClick={() => setZoom((z) => Math.max(0.5, +(z - 0.1).toFixed(2)))} data-testid="rank-zoom-out" title="Zoom out"><ZoomOut size={14} /></Button>
            <span className="w-10 text-center text-xs opacity-70" data-testid="rank-zoom-level">{Math.round(zoom * 100)}%</span>
            <Button variant="ghost" onClick={() => setZoom((z) => Math.min(2, +(z + 0.1).toFixed(2)))} data-testid="rank-zoom-in" title="Zoom in"><ZoomIn size={14} /></Button>
          </div>
        </div>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-2 border-t border-black/10 pt-2 dark:border-white/10" data-testid="rank-presets-bar">
          <span className="text-xs font-semibold opacity-70">Saved views</span>
          <select value="" onChange={(e) => { const p = presets.find((x) => x.name === e.target.value); if (p) applyPreset(p); }} data-testid="rank-preset-select"
            className="rounded-md border border-black/15 bg-transparent px-2 py-1 text-xs dark:border-white/15">
            <option value="">Apply a saved view…</option>
            {presets.map((p) => <option key={p.name} value={p.name}>{p.name}</option>)}
          </select>
          {presets.map((p) => (
            <span key={p.name} className="inline-flex items-center gap-1 rounded-full bg-black/5 px-2 py-0.5 text-[11px] dark:bg-white/10" data-testid={`rank-preset-chip-${p.name}`}>
              {p.name}
              <button onClick={() => deletePreset(p.name)} title="Delete this view" data-testid={`rank-preset-del-${p.name}`} className="opacity-60 hover:opacity-100"><X size={11} /></button>
            </span>
          ))}
          <div className="ms-auto flex items-center gap-1">
            <input value={presetName} onChange={(e) => setPresetName(e.target.value)} maxLength={40} placeholder="Name this view…" data-testid="rank-preset-name"
              className="w-40 rounded-md border border-black/15 bg-transparent px-2 py-1 text-xs dark:border-white/15" />
            <Button variant="primary" onClick={saveView} data-testid="rank-preset-save" title="Save the current arrangement as a named view"><Save size={14} /> Save view</Button>
          </div>
        </div>

      </div>

      {(ideaTallies.first.length || ideaTallies.second.length || ideaTallies.exig.length) > 0 && (
        <div className="mb-3 flex flex-wrap items-center gap-x-5 gap-y-1.5 rounded-lg border border-black/10 bg-white/50 px-3 py-2 text-[11px] dark:border-white/10 dark:bg-white/[0.03]" data-testid="idea-summary">
          {[["First Designation", ideaTallies.first], ["Second Designation", ideaTallies.second], ["Exigency", ideaTallies.exig]].map(([label, rows]) => rows.length ? (
            <div key={label} className="flex flex-wrap items-center gap-1.5">
              <span className="font-semibold opacity-70">{label}:</span>
              {rows.map(([v, n]) => {
                const active = ideaFilter && ideaFilter.key === IDEA_CAT_KEY[label] && String(ideaFilter.value) === String(v);
                return (
                  <button key={v} type="button" onClick={() => toggleFilter(IDEA_CAT_KEY[label], v)}
                    title={active ? "Clear filter" : `Highlight people with ${label} = ${v}`}
                    className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 transition ${active ? "bg-[var(--primary)] text-white" : "bg-[var(--primary)]/10 text-[var(--primary)] hover:bg-[var(--primary)]/20"}`}
                    data-testid={`idea-count-${label.replace(/\s+/g, "-").toLowerCase()}-${v}`}>{v} <b>{n}</b></button>
                );
              })}
            </div>
          ) : null)}
          {ideaFilter && (
            <span className="ms-auto inline-flex items-center gap-2">
              <span className="text-[10px] italic opacity-60">CSV &amp; Print → highlighted only</span>
              <button type="button" onClick={() => setIdeaFilter(null)} data-testid="idea-filter-clear"
                className="inline-flex items-center gap-1 rounded-full border border-black/15 px-2 py-0.5 opacity-80 hover:opacity-100 dark:border-white/15"><X size={11} /> Clear highlight</button>
            </span>
          )}
        </div>
      )}

      {groups.length === 0 && <div className="py-8 text-center text-sm opacity-60" data-testid="rank-empty">No records in this tree yet.</div>}

      {/* DEPARTMENT / UNIT VIEW — landscape tiered cards (name/title/rank, alpha by last name) with a blue banner above each group */}
      {view === "dept" && groups.length > 0 && (
        <div className="overflow-auto">
          <div style={{ transform: `scale(${zoom})`, transformOrigin: "top center", width: `${100 / zoom}%` }} className="transition-transform">
            <div className="oc" data-testid="org-chart">
              <style>{OC_CSS}</style>
              {tiers.map((tier, ti) => (
                <div key={ti} className={`oc-level${ti > 0 ? " oc-has-parent" : ""}`} data-testid={`oc-tier-${tier.rank || "unranked"}`}>
                  {ti > 0 && <div className="oc-drop" />}
                  <div className="oc-row">
                    {tier.units.map((u) => {
                      const nc = bannerColor(u);
                      const alpha = [...u.members].sort((a, b) => (a.last || "").localeCompare(b.last || "") || (a.first || "").localeCompare(b.first || ""));
                      return (
                        <div key={u.name} className="oc-cell">
                          <div className="oc-group" style={{ "--nc": nc }} data-testid={`oc-unit-${u.name}`}>
                            <div className="oc-gbar" data-testid={`oc-unit-bar-${u.name}`}>
                              <span className="rkb">{u.rank || "–"}</span>
                              <span className="nm">{u.name}</span>
                              <span className="cnt">{u.members.length}</span>
                            </div>
                            <div className="oc-cards">
                              {alpha.map((p) => {
                                const gr = gradeOf(p); const amt = gr > 0 && gradeAmount ? gradeAmount(gr) : 0;
                                return (
                                  <button key={p.id} onClick={() => onEdit && onEdit(p)} className="oc-card3" style={{ "--nc": p.color || nc, opacity: matchesFilter(p) ? 1 : 0.22, boxShadow: ideaFilter && matchesFilter(p) ? "0 0 0 2px var(--nc)" : undefined }} data-testid={`oc-node-${p.id}`}>
                                    <div className="l1">{nameOf(p)}</div>
                                    <div className="l2">{p.attrs?.title || "—"}</div>
                                    <div className="l3">{gr > 0 ? `Grade ${gr}${amt ? ` · ${fmtMoney(amt)}` : ""}` : "—"}</div>
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* UNIT RANK VIEW — tiered org chart; each unit is a boxed card (blue banner) with avatar rows salary-ranked */}
      {view === "rank" && groups.length > 0 && (
        <div className="overflow-auto" data-testid="unit-rank-view">
          <div style={{ transform: `scale(${zoom})`, transformOrigin: "top center", width: `${100 / zoom}%` }} className="transition-transform">
            <div className="oc">
              <style>{OC_CSS}</style>
              {tiers.map((tier, ti) => (
                <div key={ti} className={`oc-level${ti > 0 ? " oc-has-parent" : ""}`} data-testid={`oc-tier-${tier.rank || "unranked"}`}>
                  {ti > 0 && <div className="oc-drop" />}
                  <div className="oc-row">
                    {tier.units.map((u) => {
                      const nc = bannerColor(u);
                      return (
                        <div key={u.name} className="oc-cell">
                          <div className="oc-unit" style={{ "--nc": nc, width: widths[u.name] ? `${widths[u.name]}px` : undefined }} data-testid={`unit-rank-${u.name}`}>
                            <span className="oc-grip oc-grip-l" title="Drag to widen / narrow" onMouseDown={(e) => startResize(e, u.name, "left")} data-testid={`unit-resize-l-${u.name}`} />
                            <span className="oc-grip oc-grip-r" title="Drag to widen / narrow" onMouseDown={(e) => startResize(e, u.name, "right")} data-testid={`unit-resize-r-${u.name}`} />
                            <div className="oc-bar" data-testid={`unit-rank-bar-${u.name}`}>
                              <span className="rkb">{u.rank || "–"}</span>
                              <span className="nm">{u.name}</span>
                              <span className="cnt">{u.members.length}</span>
                            </div>
                            <div>
                              {u.members.map((p, ix) => (
                                <button key={p.id} onClick={() => onEdit && onEdit(p)} className="oc-mem" style={{ "--nc": p.color || nc, opacity: matchesFilter(p) ? 1 : 0.28 }} data-testid={`rank-card-${p.id}`}>
                                  <span className="num" data-testid={`rank-num-${p.id}`}>{ix + 1}</span>
                                  <span className="ava">
                                    {p.photo
                                      ? <img src={p.photo} alt="" style={{ transform: `rotate(${p.photo_rot || 0}deg)` }} />
                                      : <User size={15} />}
                                  </span>
                                  <span className="body">
                                    <span className="nm">{nameOf(p)}</span>
                                    {memberMeta(p) && <span className="meta">{memberMeta(p)}</span>}
                                  </span>
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
